import * as React from 'react';
import AppContainer from './AppContainer';
import {CONTENT_TYPE} from '../../Config/appConfig';

class BatchContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.BATCH}/>
        );
    }
}

export default BatchContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/BatchContainer.tsx